import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=dc98e612&scoped=true"
import script from "./academic.vue?vue&type=script&lang=js"
export * from "./academic.vue?vue&type=script&lang=js"
import style0 from "./academic.vue?vue&type=style&index=0&id=dc98e612&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc98e612",
  null
  
)

export default component.exports